import utils from "../utils";
function init() {

	var onclickElems = document.querySelectorAll('.smx-onclick');

	if(onclickElems.length > 0){
		utils.forEach(onclickElems, function (index, onclickElem) {
	
			var a = onclickElem.querySelector('a');
	
			if(a){
				var url = a.getAttribute("href");
				if(url) {
					onclickElem.setAttribute("onclick","window.location='" + url + "'");
				}
			}
		});
	}

	var overLinkWrappers = document.querySelectorAll('.over-link-wrapper');

	if(overLinkWrappers.length > 0){
		utils.forEach(overLinkWrappers, function (index, overLinkWrapper) {
	
			var a = overLinkWrapper.querySelector('a'),
				overLink = overLinkWrapper.querySelector('.over-link');
	
			if(a){
				var url = a.getAttribute("href");
				if(url) {
					overLink.setAttribute("onclick","window.location='" + url + "'");
				}
			}
		});
	}
}

export default { init };